import CoffeeIcon from '@mui/icons-material/Coffee';

const ICONS = {
  COFFEE: <CoffeeIcon />
}

export const ICON_TYPE = "icon";
export default ICONS;